import { CorePhases } from '../types';
import { PhaseManager } from './PhaseManager';
import { CustomEvents } from '@powerplay/common';
export class PhaseDisciplineManager extends PhaseManager {
    cameraManager;
    inputsManager;
    fpsManager;
    requestManager;
    constructor(cameraManager, inputsManager, fpsManager, requestManager) {
        super(cameraManager, inputsManager, fpsManager, requestManager);
        this.cameraManager = cameraManager;
        this.inputsManager = inputsManager;
        this.fpsManager = fpsManager;
        this.requestManager = requestManager;
        this.PHASE_NAME = 'DISCIPLINE';
        this.phaseNumber = CorePhases.discipline;
    }
    startPhase() {
        super.startPhase();
        window.addEventListener(CustomEvents.finishDisciplinePhase, this.finishPhase);
        window.dispatchEvent(new CustomEvent(CustomEvents.startDisciplinePhase));
    }
    finishPhase = () => {
        window.removeEventListener(CustomEvents.finishDisciplinePhase, this.finishPhase);
        super.finishPhase();
    };
}
//# sourceMappingURL=PhaseDisciplineManager.js.map